export const LogHistoryDateFilterTestIds = {
  START_DATE: 'log-history-date-filter.start-date',
  END_DATE: 'log-history-date-filter.end-date',
};
